/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fresh_Calm_Moose_RestInputs */

const en_fresh_calm_moose_rest = /** @type {(inputs: Fresh_Calm_Moose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results`)
};

const de_fresh_calm_moose_rest = /** @type {(inputs: Fresh_Calm_Moose_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse`)
};

/**
* | output |
* | --- |
* | "Results" |
*
* @param {Fresh_Calm_Moose_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fresh_calm_moose_rest = /** @type {((inputs?: Fresh_Calm_Moose_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fresh_Calm_Moose_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fresh_calm_moose_rest(inputs)
	return de_fresh_calm_moose_rest(inputs)
});